import { createAsyncTypes } from 'utils/ActionCreator'

const containerKey = 'Notifications/EndUser/Logo'

export const GET_ANNOUNCEMENTS_LOGO_ASYNC = createAsyncTypes('GET_ANNOUNCEMENTS_LOGO', containerKey)
export const SUBMIT_ANNOUNCEMENTS_LOGO_ASYNC = createAsyncTypes(
  'SUBMIT_ANNOUNCEMENTS_LOGO',
  containerKey
)
export const UPDATE_ANNOUNCEMENTS_LOGO = `${containerKey}/UPDATE_ANNOUNCEMENTS_LOGO`
